import { type TBadgeColor } from "@components/Badge/Badge";
import { RequestedSpBillStateId } from "@services/overview/types";

export const requestedBillStatusBadgeColorMap: Record<
  RequestedSpBillStateId,
  TBadgeColor
> = {
  [RequestedSpBillStateId.WAITING]: "orange",
  [RequestedSpBillStateId.CONFIRMED]: "green",
  [RequestedSpBillStateId.CANCELLED]: "red",
  [RequestedSpBillStateId.DELETED]: "red",
};
